import React, {Component} from 'react'

class InvoicePreview extends Component{
	render(){
		return("hi")
	}
}

export default InvoicePreview